export * from './src/data-v1-external-database-connection-external-database-connections.meta.js';
